import CustomButton from 'components/Buttons/CustomButton'
import PMBPagination from 'components/PMBPagination'
import PMBProfilePic from 'components/PMBProfilePic'
import SidebarDetails from 'components/SidebarDetails'
import { TableComponent as DataTable } from 'components/TableComponent'
import { Can } from 'context/Acl'
import { useAbilityAccess } from 'hooks/useAbilityAccess'
import useGetTrxApproval from 'hooks/useGetTrxApproval'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { Check, Eye, X } from 'react-feather'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Badge, Card } from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import { BUSINESS_MYAPPROVAL, MANAGE } from 'utils/subjectActions'
import { statusApproval } from '../ApprovalTable'
import ModalInfoFast from '../ModalApproval'
import { selectedData, setOpenModal } from '../approvalSlice'
import LihatDetail from 'components/Icons/LihatDetail'

const TableRequestWithdrawal = () => {
  const { enqueueSnackbar } = useSnackbar()

  const dispatch = useDispatch()
  const access = useAbilityAccess({
    action: MANAGE,
    subject: BUSINESS_MYAPPROVAL,
  })

  const { item, isOpenModal } = useSelector((s) => s.approval)
  const intl = useIntl()
  const [isOpen, setIsOpen] = useState(false)
  const [isOpen2, setIsOpen2] = useState(false)
  const [selectRows, setSelectRows] = useState(null)
  const [selectedRows, setSelectedRows] = useState([])
  const [clearRows, setClearRows] = useState(false)
  // const [showAlertError, setShowAlertError] = useState(false)
  // const [showAlertSuccess, setShowAlertSuccess] = useState(false)

  const [pagination, setPagination] = useState({ size: 10, page: 0 })

  const trxApproval = useGetTrxApproval({
    filter: 'Request withdrawal',
    page: pagination.page ?? 0,
    size: pagination.size ?? 0,
  })

  const toggle = () => setIsOpen(!isOpen)

  const toggleClearRows = () => {
    setClearRows(!clearRows)
  }

  const toggleSidebar = (payload) => {
    if (payload) {
      dispatch(selectedData(payload))
    }
  }

  const toggleFastApprove = (payload, type) => {
    setIsOpen2(!isOpen2)
    setSelectRows({ data: payload, type })
  }

  const handleSelect = (e) => {
    setSelectedRows(e)
  }

  const columns = [
    {
      name: <span>Pemohon</span>,
      sortable: true,
      cell: (row) => (
        <div className="flex-centered gap-2">
          <PMBProfilePic
            imgSrc={row?.makerAvatar}
            altText={row?.makerName}
            name={row?.makerName}
            avatarSeed={row?.makerUserId}
            width={20}
            height={20}
          />
          <span>{row?.makerName}</span>
        </div>
      ),
      minWidth: '150px',
    },
    {
      name: (
        <div
          style={{
            textAlign: 'right',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          Nominal
        </div>
      ),
      cell: (row) => (
        <div className="d-flex justify-content-end w-100">
          <span>
            Rp
            {newFormatThousandSeparator(row?.instantWithdrawal?.amount ?? 0, 0)}
          </span>
        </div>
      ),
      minWidth: '150px',
    },
    {
      name: <span>Jenis Penarikan</span>,
      sortable: true,
      cell: (row) => <span>Instan {row?.instantWithdrawal?.title}</span>,
      minWidth: '150px',
    },
    {
      name: '',
      cell: (row) => {
        return (
          <>
            <LihatDetail
              onClick={() => {
                toggleSidebar(row)
                dispatch(setOpenModal(true))
              }}
              id={row?.id}
              data-testid={`approval-row-${row?.id}`}
            />

            {access && (
              <>
                <X
                  size={18}
                  className="text-danger fw-bold mx-1"
                  style={{ cursor: 'pointer' }}
                  data-testid="approval-action-reject-button"
                  onClick={() => {
                    toggleFastApprove([row], statusApproval.withdrawReject)
                  }}
                />
                <Check
                  size={18}
                  className="text-success fw-bold mx-1"
                  style={{ cursor: 'pointer' }}
                  data-testid="approval-action-approve-button"
                  onClick={() => {
                    toggleFastApprove([row], statusApproval.withdrawApprove)
                  }}
                />
              </>
            )}
          </>
        )
      },
      minWidth: '100px',
    },
  ]

  const handleMessageAlert = (message, type) => {
    enqueueSnackbar(message, {
      variant: type,
    })
  }

  return (
    <>
      <Card body className="mb-3 border-0 p-0" data-testid="approval-table-withdraw">
        <div className="d-flex justify-content-between align-items-center">
          {selectedRows?.selectedCount > 0 ? (
            <div className="d-flex gap-3 align-items-center justify-content-center">
              <span className="text-muted">
                {selectedRows?.selectedCount} transaksi terpilih
              </span>
              <div className="d-flex gap-2">
                <CustomButton
                  onClick={() => {
                    toggleFastApprove(
                      selectedRows?.selectedRows,
                      statusApproval.withdrawReject,
                    )
                  }}
                  className="rounded"
                  size="sm"
                  color="danger"
                  outline
                  testId="approval-action-reject-button"
                >
                  {' '}
                  <X size={20} />{' '}
                </CustomButton>
                <CustomButton
                  onClick={() => {
                    toggleFastApprove(
                      selectedRows?.selectedRows,
                      statusApproval.withdrawApprove,
                    )
                  }}
                  className="rounded"
                  size="sm"
                  color="success"
                  outline
                  testId="approval-action-approve-button"
                >
                  {' '}
                  <Check size={20} />{' '}
                </CustomButton>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        {/* <Alert
          color="success"
          isOpen={showAlertSuccess}
          toggle={() => setShowAlertSuccess(false)}
          className="mb-2 mt-2"
        >
          <CheckCircle className="text-success me-2" size={16} />
          <span>Penarikan berhasil disetujui.</span>
        </Alert>
        <Alert
          color="danger"
          isOpen={showAlertError}
          toggle={() => setShowAlertError(false)}
        >
          <CheckCircle className="text-success me-2" size={16} />
          <span>Penarikan berhasil dibatalkan.</span>
        </Alert> */}
        <DataTable
          columns={columns}
          selectableRows
          onSelectedRowsChange={handleSelect}
          clearSelectedRows={clearRows}
          data={trxApproval?.data?.items}
          progressPending={trxApproval?.isLoading}
          pagination
          paginationServer
          paginationComponent={(props) => (
            <PMBPagination
              rowCount={trxApproval?.data?.totalItems || 0}
              currentPage={pagination?.page}
              rowsPerPage={pagination?.size}
              setCurrentPage={(e) => {
                setPagination((prev) => ({
                  ...prev,
                  page: e,
                }))
              }}
              setRowsPerPage={(e) => {
                setPagination((prev) => ({
                  ...prev,
                  size: e,
                }))
              }}
              props={props}
            />
          )}
        />
      </Card>
      <SidebarDetails
        open={isOpenModal}
        title="Data Transaksi"
        headerClassName="mb-1"
        contentClassName="pt-0"
        size="lg"
        toggleSidebar={() => {
          dispatch(setOpenModal(false))
          toggleSidebar()
        }}
      >
        <div className="d-flex flex-column gap-3 mb-5">
          <div>
            <Badge size="sm" disabled className="badge-warning mt-1">
              {item?.status}
            </Badge>
          </div>
          <Card className="border-0 shadow-sm" body>
            <span className="fw-bold">Pemohon</span>
            <div className="d-flex align-items-center gap-2">
              <PMBProfilePic
                imgSrc={item?.makerAvatar}
                altText={item?.makerName}
                name={item?.makerName}
                avatarSeed={item?.makerUserId}
                width={20}
                height={20}
              />
              <span>{item?.makerName}</span>
            </div>
          </Card>
          <Card className="border-0 shadow-sm" body>
            <p className="fw-bold">Rincian Penarikan</p>
            <div className="d-flex justify-content-between align-items-center">
              <p>Nominal</p>
              <p>
                Rp
                {intl.formatNumber(item?.instantWithdrawal?.amount ?? 0, {
                  useGrouping: 'always',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
              </p>
            </div>
            <div className="d-flex justify-content-between align-items-start">
              <p>
                {`Biaya penarikan `}
                <br />
                <small>
                  <span className="text-danger">*</span>
                  {`sudah termasuk PPN`}
                </small>
              </p>
              <p>
                Rp
                {intl.formatNumber(item?.instantWithdrawal?.fee ?? 0, {
                  useGrouping: 'always',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
              </p>
            </div>
            <div className="d-flex justify-content-between align-items-start">
              <p className="fw-bold">Nominal yang diterima</p>
              <p>
                Rp
                {intl.formatNumber(
                  item?.instantWithdrawal?.amount ??
                    0 - item?.instantWithdrawal?.fee ??
                    0,
                  {
                    useGrouping: 'always',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  },
                )}
              </p>
            </div>
            <div
              className="rounded p-3 d-flex gap-3 align-items-center"
              style={{
                backgroundColor: '#F3FEFF',
                borderColor: '#8ABBCC',
                borderStyle: 'solid',
                borderWidth: '1px',
              }}
            >
              <div>
                <img
                  alt="bca logo"
                  style={{ maxHeight: '30px', maxWidth: '30px' }}
                  src={item?.instantWithdrawal?.bankLogo}
                />
              </div>
              <div className="d-flex flex-column ">
                <span>{item?.instantWithdrawal?.bankAccountName}</span>
                <span>
                  {item?.instantWithdrawal?.bankCode}{' '}
                  {item?.instantWithdrawal?.bankAccountNumber}
                </span>
              </div>
            </div>
          </Card>
        </div>
        <Can I={MANAGE} this={BUSINESS_MYAPPROVAL}>
          <div className="d-flex justify-content-between gap-3 w-100">
            <CustomButton
              className="btn-cancel"
              block
              size="sm"
              outline
              onClick={() => {
                toggleFastApprove([item], statusApproval.withdrawReject)
              }}
              testId="approval-action-reject-button"
            >
              Tolak
            </CustomButton>
            <CustomButton
              block
              color="primary"
              size="sm"
              onClick={() => {
                toggleFastApprove([item], statusApproval.withdrawApprove)
              }}
              testId="approval-action-approve-button"
            >
              Setujui
            </CustomButton>
          </div>
        </Can>
      </SidebarDetails>

      <ModalInfoFast
        isOpen={isOpen2}
        requestData={selectRows}
        toggleClearRows={toggleClearRows}
        setIsOpen={setIsOpen2}
        toggle={() => {
          toggleFastApprove()
          dispatch(setOpenModal(false))
        }}
        toggleSuccess={() => {
          if (item) {
            // toggleSidebar()
            // setShowAlertSuccess(true)
            handleMessageAlert('Transaksi berhasil disetujui', 'success')
            trxApproval.refetch()
            toggleClearRows()
            setSelectedRows([])
          } else {
            // setShowAlertSuccess(true)
            handleMessageAlert('Transaksi berhasil disetujui', 'success')
            trxApproval.refetch()
            toggleClearRows()
            setSelectedRows([])
          }
        }}
        toggleReject={() => {
          if (item) {
            // toggleSidebar()
            // showAlertError(true)
            handleMessageAlert('Transaksi berhasil dibatalkan', 'success')
            trxApproval.refetch()
            toggleClearRows()
            setSelectedRows([])
          } else {
            // setShowAlertError(true)
            handleMessageAlert('Transaksi berhasil dibatalkan', 'success')
            trxApproval.refetch()
            toggleClearRows()
            setSelectedRows([])
          }
        }}
      />
    </>
  )
}

export default TableRequestWithdrawal
